//首页
import websiteIndex from './views/websiteIndex/route';
//开发中页面
import developing from './views/developing/route';
//新闻中心
import newsCenter from './views/newsCenter/route';
import onlineRoute from './views/online/route';
import appointmentVisitor from './views/appointmentVisitor/route';
import authenticationRedirect from './views/authenticationRedirect/route';
import reportRouter from './report/route';
export default Object.assign({}, websiteIndex, developing, newsCenter, onlineRoute, appointmentVisitor, authenticationRedirect, reportRouter, { formDetail: {
        path: '/form/detail',
        name: 'form-detail',
        component: () => import('@/views/form/form-detail.vue')
    }, application: {
        qckanban: {
            path: 'qckanban',
            name: 'qckanban',
            component: () => import('./views/qckanban/qckanban.vue')
        }
    } });
